import { parseLivePath } from '~/lib/params'
import { STAGE_LEFT, STAGE_TOP } from '~/lib/stage'
import display_object_schema from '~/schemas/display_object_schema'

/** The `_v` this step produces. Settings stamped below it carry root `x`/`y` from the stage's top-left corner. */
export const STAGE_CENTRE_VERSION = 10

const SHIFT = { x: STAGE_LEFT, y: STAGE_TOP }

const positioned = obj => !!display_object_schema.definitions[obj?.type]?.properties?.x

const atRoot = (id, obj) => id !== 'root' && (obj.parentId ?? 'root') === 'root' && positioned(obj)

/** Root `x`/`y`, and loops on them, shift to the centred frame. ⚠️ Gated on a numeric `_v` alone, like `originToPivot`: no key says whether it ran. */
export function stageCentre(settings) {
	const v = settings?._v
	if (typeof v !== 'number' || v >= STAGE_CENTRE_VERSION) return settings
	const objects = settings.objects
	if (!objects || typeof objects !== 'object') return settings

	const next = {}
	for (const [id, obj] of Object.entries(objects)) {
		next[id] =
			obj && typeof obj === 'object' && atRoot(id, obj)
				? { ...obj, x: (obj.x ?? 0) + SHIFT.x, y: (obj.y ?? 0) + SHIFT.y }
				: obj
	}

	let modulators = settings.modulators
	if (modulators && typeof modulators === 'object') {
		modulators = { ...modulators }
		for (const [path, def] of Object.entries(modulators)) {
			const p = parseLivePath(path)
			const obj = p?.scope === 'object' && objects[p.id]
			if (!obj || !(p.key in SHIFT) || !atRoot(p.id, obj) || !def || typeof def !== 'object') continue
			const d = SHIFT[p.key]
			modulators[path] = {
				...def,
				...(Number.isFinite(def.in) && { in: def.in + d }),
				...(Number.isFinite(def.out) && { out: def.out + d }),
			}
		}
	}

	return { ...settings, objects: next, ...(modulators && { modulators }) }
}

export default stageCentre
